import { render, staticRenderFns } from "./ResourceListPage.vue?vue&type=template&id=646c9e88&scoped=true&"
import script from "./ResourceListPage.vue?vue&type=script&lang=js&"
export * from "./ResourceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c9e88",
  null
  
)

export default component.exports